import { render, staticRenderFns } from "./SafetyObservationViewForm.vue?vue&type=template&id=c740ed90&"
import script from "./SafetyObservationViewForm.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationViewForm.vue?vue&type=script&lang=js&"
import style0 from "./SafetyObservationViewForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports